// form fields
export const FULL_NAME_FIELD_NAME = 'fullName'
export const LOGIN_FIELD_NAME = 'login'
export const ENABLED_FIELD_NAME = 'enabled'
export const IS_LOCKED_FIELD_NAME = 'isLocked'

export const IS_EMAILING_IN_WORKFLOW_FIELD_NAME = 'isEmailingInWorkflow'
export const IS_EMAILING_IN_CHAT_FIELD_NAME = 'isEmailingInChat'
export const IS_EMAILING_IN_GAMIFICATION_SIGN_UP_FIELD_NAME =
  'isEmailingInGamificationSignUp'
export const IS_EMAILING_IN_GAMIFICATION_REDEMPTION_FIELD_NAME =
  'isEmailingInGamificationRedemption'
export const IS_NOTIFY_EMERGENCY_RISK_LEVEL_FIELD_NAME =
  'isNotifyEmergencyRiskLevel'
export const IS_URGENT_CARE_CLINICIAN_FIELD_NAME = 'isUrgentCareClinician'
export const URGENT_CARE_POPUP_NOTIFICATION_ON_CREATION_FIELD_NAME =
  'urgentCarePopupNotificationOnCreation'
export const URGENT_CARE_EMAIL_NOTIFICATION_ON_CREATION_FIELD_NAME =
  'urgentCareEmailNotificationOnCreation'
export const URGENT_CARE_SMS_NOTIFICATION_ON_CREATION_FIELD_NAME =
  'urgentCareSmsNotificationOnCreation'
export const URGENT_CARE_POPUP_NOTIFICATION_ON_ASSIGNMENT_FIELD_NAME =
  'urgentCarePopupNotificationOnAssignment'
export const URGENT_CARE_EMAIL_NOTIFICATION_ON_ASSIGNMENT_FIELD_NAME =
  'urgentCareEmailNotificationOnAssignment'
export const URGENT_CARE_SMS_NOTIFICATION_ON_ASSIGNMENT_FIELD_NAME =
  'urgentCareSmsNotificationOnAssignment'
export const IS_NOTIFY_MEDICAL_DEVICE_TRAINING_STATUS_UPDATE_FIELD_NAME =
  'isNotifyMedicalDeviceTrainingStatusUpdate'
export const BILLING_REQUIRED_FIELD_NAME = 'billingRequired'
export const IS_START_TIMER_ON_CHART_REVIEW_FIELD_NAME =
  'isStartTimerOnChartReview'
export const TASK_MANAGER_NOTIFICATION_FIELD_NAME = 'taskManagerNotification'
export const TWO_FACTOR_AUTH_FIELD_NAME = 'twoFactorAuth'
export const IS_SEND_ACTIONS_WITHOUT_ASSIGNEE = 'isSendActionsWithoutAssignee'
export const IS_MANUAL_VIDEO_CALL_ALLOWED = 'isManualVideoCallAllowed'
export const CAN_EDIT_MEASUREMENT_REPORTED_BY = 'isCanEditMeasurementReportedBy'
export const IS_AI_RISK_FACTOR_READ_ENABLED = 'isAIRiskFactorReadEnabled'
export const IS_AI_RISK_FACTOR_GENERATE_ENABLED =
  'isAIRiskFactorGenerateEnabled'
export const IS_AI_TRANSCRIPTION_READ_ENABLED = 'isAITranscriptionReadEnabled'
export const IS_SUPPORT_USER_FIELD_NAME = 'isSupportUser'
export const IS_MOBILE_CLINICIAN_LOGIN_ALLOWED = 'isMobileClinicianLoginAllowed'
export const ACTION_POINTS_FIELD_NAME = 'isAllowedActionPoints'
export const EMAIL_FIELD_NAME = 'email'
export const FIRST_NAME_FIELD_NAME = 'firstName'
export const LAST_NAME_FIELD_NAME = 'lastName'
export const COMPANY_DIVISION_FIELD_NAME = 'companyDivision'
export const UC_NOTIFICATION_PER_PROVIDER =
  'urgentCareNotificationsPerProviders'
export const CASE_MANAGERS_FIELD_NAME = 'caseManagers'
export const PROVIDERS_FIELD_NAME = 'providers'
export const REFERRAL_SOURCES_FIELD_NAME = 'referralSources'
export const FACILITIES_FIELD_NAME = 'facilities'
export const ROLES_FIELD_NAME = 'roles'
export const ROLE_FIELD_NAME = 'role'
export const IS_DELETE_SOAP_VISIT_ENABLED = 'isDeleteSoapVisitEnabled'
export const IS_SOAP_SIGNED_TO_DRAFT_ENABLED = 'isSoapSignedToDraftEnabled'
export const IS_TASK_SUPER_MANAGER_FIELD_NAME = 'isTaskSuperManager'
export const PHONE_FIELD_NAME = 'phone'
export const CASE_MANAGER_NOTIFICATIONS_FIELD_NAME = 'caseManagerNotifications'
export const DEFAULT_CLINICIAN_FIELD_NAME = 'defaultClinicians'
export const NOTE_FIELD_NAME = 'note'
export const UUID_FIELD_NAME = 'uuid'
export const ENROLMENT_SPECIALIST_FIELD_NAME = 'isEnrollmentSpecialist'
export const TASK_TYPE_SUBSCRIPTION_FIELD_NAME = 'taskTypeSubscriptions'
export const IS_NON_BILLABLE_ACTIVIVTY_LOG = 'isNonBillableActivityLog'
export const IS_URGENT_CARE_POPUP_NOTIFICATION_SOUND =
  'isUrgentCarePopupNotificationSound'
export const APPOINTMENT_TYPE = 'appointmentType'
export const APPOINTMENT_CALL_TYPES = 'appointmentCallTypes'
export const POSITIVE_HANDICAP_FIELD_NAME = 'positiveHandicap'

// route
export const COMPANY_USERS_GET_LIST = 'company/employees/company/:companyUuid'
export const COMPANY_USERS_CREATE_USER = 'company/employees'
export const COMPANY_USERS_UPDATE_USER = 'company/employees/:userUuid'
export const COMPANY_USERS_UNLOCK_USER = 'auth/user/:userUuid/unlock'

// sort
export const COMPANY_USERS_DEFAULT_SORT = {
  sortedColumn: 'firstName',
  sortedColumnOrder: 'ascend'
}

export const COMPANY_USERS_USER_STATUSES = [
  {
    label: 'Active',
    value: true
  },
  {
    label: 'Inactive',
    value: false
  }
]

export const COMPANY_USERS_USER_STATUSES_WITH_PENDING = [
  {
    label: 'Active',
    value: true
  },
  {
    label: 'Inactive',
    value: false
  },
  {
    label: 'Pending',
    value: 3
  }
]

export const APPOINTMENT_TYPES_DROPDOWN = [
  {
    key: 0,
    label: 'All',
    value: 3
  },
  {
    key: 1,
    label: 'Overnight',
    value: 1
  },
  {
    key: 2,
    label: 'Community',
    value: 2
  }
]

export const APPOINTMENT_CALL_TYPES_MESSAGE =
  'The telemedicine badge counter will display the number of incoming calls exclusively for the selected appointment types.'

export const rangesName = 'ipAddressRanges'
export const startIpName = 'ipStart'
export const endIpName = 'ipEnd'
